// Whitelist `returnTo` to relative paths only. We accept `/foo` but reject:
//   - protocol-relative URLs like `//evil.com` (open redirect)
//   - absolute URLs with a scheme like `https://evil.com`
//   - anything that doesn't start with a single leading slash
// Used by /invite/:token → /login?returnTo=/invite/:token round-trips so
// the buyer lands back on the accept page after signing in.
export function safeReturnTo(raw) {
  if (!raw) return '/dashboard';
  if (!/^\/(?!\/)/.test(raw)) return '/dashboard';
  return raw;
}
